import { defineStore } from "pinia";
import { computed, ref } from "vue";
import useMyFetch from "./useMyFetch";

export const useConstantsStore = defineStore("constants", () => {
  // state
  const constants = ref([]);

  // getters
  const cardTypesGroupNames = { MESSAGES: "message", OTHER: "other", QUESTIONS: "question", STANDARD: "standard" };
  const cardTypesGroups = computed(() => {
    const groups = constants.value?.card_types_groups ?? {};

    return Object.entries(groups).map(([name, group]) => [cardTypesGroupNames[name] ?? name, group]);
  });
  const cardRecodeParams = computed(() => constants.value?.recode_params ?? {});
  const recodeZonings = computed(() => constants.value?.recode_zonings ?? []);
  const customCardParams = computed(() => constants.value?.other_card_methods ?? {});
  const cardSubTypes = computed(() =>
    Object.values(cardTypesGroups.value)
      .map(([, group]) => group)
      .reduce((previous, current) => previous.concat(current)),
  );
  const cardSubTypesInfos = computed(() => constants.value?.card_types ?? {});
  const cardSettings = computed(() => constants.value?.card_options ?? {});
  const rewardCurrencies = computed(() => constants.value?.reward_currencies ?? {});
  const getCardTypeGroupName = computed(
    () => (subType) =>
      cardTypesGroups.value.find(([, group]) => group.find((otherSubType) => otherSubType === subType))?.[0],
  );
  // actions
  async function fetchConstants() {
    const { data } = await useMyFetch("/constants").json();
    constants.value = data.value;
  }

  return {
    // state
    constants,

    // actions
    fetchConstants,

    // getters
    cardTypesGroups,
    cardSubTypes,
    cardSettings,
    cardSubTypesInfos,
    rewardCurrencies,
    cardRecodeParams,
    recodeZonings,
    customCardParams,
    getCardTypeGroupName,
  };
});
